<template>
	<div>
		<!-- 处方 -->
		<Popup v-model="prescription_display" title="处方信息" confirmBtnText="提交" @confirmClick="handlePrescriptionSubmit">
			<div v-loading="prescription_loading" style="padding: 15px;">
				<div class="prescription_table">
					<table>
						<tr>
							<th style="width: 180px;">项目</th>
							<th>处方</th>
						</tr>
						<tr v-for="(v, i) in preList" :key="v.productId">
							<td style="padding: 10px;text-decoration: underline;cursor: pointer;"
								@click="handleTaskNameClick(v.productId, v.productPatientRelativeId, v.productParams)">
								{{ v.productName }}
							</td>
							<td>
								<div v-for="(fv, fi) in v.eglProductParamsDetailsVo" :key="fi" :class="{'border_r': fi == 0}"
									style="float: left;width: 50%;">
									<div class="cell border_b">{{ fv.name }}</div>
									<div class="cell">
										<el-select :value="v.trainList[fi].num" style="width: 110px;"
											@change="handlePrescriptionSelectChange($event, i, v.trainList[fi].type)">
											<el-option :value="0"></el-option>
											<el-option :value="1"></el-option>
											<el-option :value="2"></el-option>
											<el-option :value="3"></el-option>
											<el-option :value="4"></el-option>
										</el-select>
										{{ v.paramsFrequency }}
									</div>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</Popup>
		<!-- 处方 end -->

		<!-- 任务 -->
		<Popup v-model="task_display" title="修改任务" confirmBtnText="提交" @confirmClick="handleTaskSubmit">
			<div v-loading="task_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label">视知觉任务</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="vision_task_ids">
							<el-checkbox v-for="v in vision_task_list" :key="v.missionId" :label="v.missionId"
								:disabled="v.missionId == 1">{{ v.missionName }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">双眼视任务</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="eyes_task_ids">
							<el-checkbox v-for="v in eyes_task_list" :key="v.missionId"
								:label="v.missionId">{{ v.missionName }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
		</Popup>
		<!-- 任务 end -->
	</div>
</template>

<script>
	import Api from "../../../../../api/index.js"
	import {
		mapState
	} from "vuex"

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: [Number, String],
				required: true
			},
			fid: {
				type: [Number, String],
				required: true
			},
			code: {
				type: [Number, String],
				required: true
			}
		},
		mounted() {
			this.display && (this.prescription_display = true);
		},
		data() {
			return {
				prescription_loading: false,
				prescription_display: false,
				preList: [],

				task_display: false,
				task_loading: false,
				taskProductId: '',
				taskRelativeId: '',
				vision_task_list: [],
				vision_task_ids: [],
				eyes_task_list: [],
				eyes_task_ids: []
			}
		},
		computed: {
			...mapState([
				'allProduct'
			])
		},
		methods: {
			// 请求处方数据
			getPrescriptionData() {
				const that = this;
				that.prescription_loading = true;
				var _requestData = {
					uCode: that.code,
					uEnterpriseId: that.fid
				};
				Api.findAgentPrescription(_requestData).then((res) => {
					that.prescription_loading = false;
					if (res.data.success) {
						that.preList = [];
						res.data.data.forEach(v => {
							v["trainList"] = [];
							if (v.eglProductParamsDetailsVo) {
								if (v.eglProductParamsDetailsVo.length < 2 && v.productId == 0) {
									v.paramsInfo = '4,0'
									v._type = '0,1'
									v.paramsName = 'S,D'
									v.eglProductParamsDetailsVo.push({
										frequency: "节/天",
										name: "双眼视训练",
										num: "0"
									})
								}
							}


							var _info = v.paramsInfo ? v.paramsInfo.split(",") : [];
							var _type = v.paramsName ? v.paramsName.split(",") : [];

							_info.forEach((vi, ii) => {
								v["trainList"].push({
									num: parseInt(vi),
									type: _type[ii]
								});
							});
							that.preList.push(v);
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.prescription_loading = false;
					that.$message.error(e.message);
				});
			},
			// 改变处方次数
			handlePrescriptionSelectChange(num, index, type) {
				var _l = [...this.preList];

				//正对趣味版2.0 做出厨房调整
				_l.forEach((v, i) => {
					// if (v.productId == 0) {
					// 	if (type == 'S') {
					// 		v.trainList[0].num = num
					// 	} else if (type == 'D') {
					// 		v.trainList[1].num = num
					// 	}
					// } else {
					// 	if (i == index) {
					// 		v.trainList.forEach(vi => {
					// 			console.log(vi)
					// 			if (vi.type == type) {
					// 				vi.num = num;
					// 			} else {
					// 				num + vi.num > 4 &&
					// 					(vi.num = Math.ceil(4 - num));
					// 			}
					// 		});
					// 	}
					// }

					if (i == index) {
						v.trainList.forEach(vi => {
							console.log(vi)
							if (vi.type == type) {
								vi.num = num;
							} else {
								num + vi.num > 4 &&
									(vi.num = Math.ceil(4 - num));
							}
						});
					}
				});



				this.preList = _l;


			},
			// 修改处方信息
			handlePrescriptionSubmit() {
				const that = this;
				that.prescription_loading = true;
				var _data = [];
				that.preList.forEach(v => {
					var _o = {};
					var _info = [];
					var _name = [];
					_o.paramsFrequency = v.paramsFrequency;
					_o.productParamsDetailsId = v.paramsDetailsId;
					v.trainList.forEach(vi => {
						_name.push(vi.type);
						_info.push(vi.num);
					});
					_o.paramsName = _name.length ? _name.join(",") : "";
					_o.paramsInfo = _info.length ? _info.join(",") : "";
					_data.push(_o);
				});
				// console.log(_data);
				var _requestData = {
					id: 123,
					productList: _data,
					userId: that.uid,
					uenterpriseId: that.fid
				};
				Api.updateUserPrescription(_requestData).then((res) => {
					that.prescription_loading = false;
					if (res.data.success) {
						that.prescription_display = false;
						that.$emit("updatePrescription", res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.prescription_loading = false;
					that.$message.error(e.message);
				});
			},

			// 点击任务
			handleTaskNameClick(productId, relativeId, params) {
				const that = this;
				let list = [];
				let eyes_task_ids = params ? params.split(",") : [];
				that.taskProductId = productId;
				that.taskRelativeId = relativeId;
				eyes_task_ids.forEach(v => {
					if (v >= 1 && v <= 14) {
						that.vision_task_ids.push(v);
					} else {
						that.eyes_task_ids.push(v);
					}
				});
				that.allProduct.forEach(v => {
					if (v.id == that.taskProductId) {
						list = v.child;
					}
				});
				list.forEach(v => {
					if (v.missionId >= 1 && v.missionId <= 14) {
						that.vision_task_list.push(v);
					} else {
						that.eyes_task_list.push(v);
					}
				});
				// that.prescription_display = false;
				that.task_display = true;
			},
			// 修改任务
			handleTaskSubmit() {
				const that = this;
				that.task_loading = true;
				var _requestData = {
					productParams: that.vision_task_ids.concat(that.eyes_task_ids).join(','),
					productPatientRelativeId: that.taskRelativeId,
					isEnabled: 1
				};
				Api.updateUserTask(_requestData).then((res) => {
					that.task_loading = false;
					if (res.data.success) {
						that.task_display = false;
						that.$message.success(res.data.message);
						that.getPrescriptionData();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.task_loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newValue) {
				this.prescription_display = newValue;
			},
			prescription_display(newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.prescription_loading = false;
					this.preList = [];

					this.getPrescriptionData();
				}
			},
			task_display(newValue) {
				if (!newValue) {
					this.task_loading = false;
					this.taskProductId = '';
					this.taskRelativeId = '';
					this.vision_task_list = [];
					this.vision_task_ids = [];
					this.eyes_task_list = [];
					this.eyes_task_ids = [];
				}
			}
		}
	}
</script>

<style>
	.prescription_table {
		border-top: 1px solid #ccc;
		border-left: 1px solid #ccc;
	}

	.prescription_table table {
		width: 100%;
	}

	.prescription_table th {
		padding: 10px;
		border-right: 1px solid #ccc;
		text-align: center;
	}

	.prescription_table tr {
		border-bottom: 1px solid #ccc;
	}

	.prescription_table td {
		border-right: 1px solid #ccc;
		text-align: center;
	}

	.prescription_table .cell {
		display: block;
		padding: 10px;
	}
</style>